import React from 'react';
import { Toolbar, Stack, SxProps, Theme } from '@mui/material';

export interface PanelFooterProps {
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PanelFooter: React.FC<PanelFooterProps> = ({ leftItems, rightItems, sx }) => {
  return (
    <Toolbar
      className='lex-panel-footer'
      sx={sx}
    >
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
        sx={{ flexGrow: 1 }}
      >
        {leftItems}
      </Stack>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
      >
        {rightItems}
      </Stack>
    </Toolbar>
  );
};

export default PanelFooter;
